import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/bimestre/';

/**
 * GET SBCBimestres
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSBCBimestres = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET SBCBimestres
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSBCBimestresParams = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET SBCBimestre
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSBCBimestre = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST SBCBimestre
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSBCBimestre = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH SBCBimestre
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSBCBimestre = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE SBCBimestre
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteSBCBimestre = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR SBCBimestres
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarSBCBimestres = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
